import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { GetProviderScoreHistoryQuery, ProviderScoreHistoryResponse } from '../types';
import { PROVIDER_SCORE_HISTORY_KEY } from './constants';

const useGetProviderScoreHistory = (query?: GetProviderScoreHistoryQuery) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        return req<ProviderScoreHistoryResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/provider-score-history/`,
            query
        });
    }, [req, query]);

    return useQuery({
        queryFn: request,
        queryKey: [PROVIDER_SCORE_HISTORY_KEY, query]
    });
};

export default useGetProviderScoreHistory;
